import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import CardDesignerCardElementPlaceholder from '../CardDesignerCardElementPlaceholder';
import BarcodeIcon from '../../../../../icons/BarcodeIcon';

const propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  element: PropTypes.shape({
    cardElement: PropTypes.object.isRequired,
    cardElementConfiguration: PropTypes.object.isRequired,
  }).isRequired,
};

const CardDesignerCardElementBarcode = ({ className, onClick, element }) => {
  const classes = classNames({
    'card-designer-card-element': true,
    'card-designer-card-element-barcode': true,
    [className]: !!className,
  });

  const { cardElementConfiguration } = element;

  return (
    <a
      href="#"
      className={classes}
      onClick={event => {
        event.preventDefault();
        onClick();
      }}
    >
      <CardDesignerCardElementPlaceholder
        style={{
          backgroundColor: cardElementConfiguration.color,
        }}
        icon={
          <div className="d-flex flex-column align-items-center text-light text-xs">
            <BarcodeIcon color="#646e71" size="48" className="mb-1" />
            BARCODE
          </div>
        }
      />
    </a>
  );
};

CardDesignerCardElementBarcode.propTypes = propTypes;

export default CardDesignerCardElementBarcode;
